:host {
  display: block;

  .av-card-header {
    padding: 8px 12px 8px;
    background-color: var(--av-color-accent);
    color: var(--av-color-accent-contrast);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    border-radius: var(--av-border-radius-container)
      var(--av-border-radius-container) 0 0;
  }

  .av-card-header-title {
    flex: 1;
  }

  .av-card-header-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

av-asset {
  width: 100%;
}
